import { Table, Button } from "react-bootstrap";
import "reactjs-popup/dist/index.css";
import GiveReviews from "./GiveReviews";
import React from "react";
import "./ReviewForm.css";

export default function ReviewForm() {
  return (
    <div className="reviews-page">
      <h2>Consultation Reviews</h2>
      <div className="reviews-table">
        <Table responsive className="mb-0">
          <thead>
            <tr>
              <th>#</th>
              <th>Doctor</th>
              <th>Speciality</th>
              <th>Feedback</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Dr. Michael Loe</td>
              <td>Cardiology</td>
              <td>
                <GiveReviews />
              </td>
              <td>—</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Dr. Jason Lee</td>
              <td>Orthopedy</td>
              <td>
                <GiveReviews />
              </td>
              <td>—</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Dr. Paula Boe</td>
              <td>Dermatology</td>
              <td>
                <Button variant="primary" disabled size="sm">
                  Review Submitted
                </Button>
              </td>
              <td>Great consultation</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  );
}
